/**
 * OrderManagement Component
 * Re-exported OrderListPage with advanced search and filters
 *
 * Features:
 * - Search by order number, customer name, status
 * - Filters: Status, Date Range, Amount Range, Location, Customer Type
 * - Pagination, Export, Sorting
 * - URL-persisted filters
 *
 * @author SAUBHAGYA Development Team
 */

import { OrderListPage } from '@/pages/commerce/orders/OrderListPage';

const OrderManagement = OrderListPage;

export default OrderManagement;
